import React, { useEffect, useState } from 'react';
import { NavLink, withRouter } from 'react-router-dom';

import AlertService from '../../../../components/SweetAlert';
import ToastUtil from '../../../../components/ToastNotification/ToastUtil';
import { newFetch, POST } from '../../../../helpers/fetch';
import AppContext from '../../../../store/App/contexts';
import LayoutContext from '../../../../store/Layout/contexts';

const AddEsignDocument = ({ history }) => {
  const type = localStorage.getItem('type');
  const { fetchClientsOptions, client_options, selectedClientID } =
    React.useContext(AppContext);
  const [status, setStatus] = useState('Pending');
  const [name, setName] = useState('');
  const [nricFin, setNricFin] = useState('');
  const [salary, setSalary] = useState('');
  const [address, setAddress] = useState('');

  useEffect(() => {
    fetchClientsOptions(type);
  }, []);

  const handleDiscard = async () => {
    const isConfirmed = await AlertService.confirm(
      '',
      'Are you sure you want to discard all changes?'
    );
    if (isConfirmed) {
      setStatus(0);
      setName('');
      setSalary('');
      setAddress('');
      setNricFin('');
    }
  };

  const validateForm = () => {
    if (!status) {
      ToastUtil.error('Select status');
      return false;
    }

    if (!name) {
      ToastUtil.error('Enter Name');
      return false;
    }

    if (!nricFin) {
      ToastUtil.error('Enter last 4 digits of nric');
      return false;
    }

    if (!salary) {
      ToastUtil.error('Enter salary');
      return false;
    }

    if (!address) {
      ToastUtil.error('Enter address');
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      validateForm() &&
      (await AlertService.confirm(
        '',
        'Are you sure you want to add this record?'
      ))
    ) {
      let api_path = `/esign_document`;
      let response = await newFetch(POST, api_path, {
        status,
        name,
        salary,
        address,
        nric_fin: nricFin,
      });

      ToastUtil.success(response.message);

      if (response.success) {
        history.push('/esign_document');
      }
    }
  };

  return (
    <LayoutContext.Consumer>
      {({ activeSidebar }) => {
        return (
          <div style={{ paddingTop: '3rem' }}>
            <div
              className="d-flex flex-column"
              style={{ paddingLeft: '3rem', paddingRight: '3rem' }}
            >
              <NavLink
                to="/esign_document"
                className="text-decoration-none"
                style={{ color: 'inherit' }}
              >
                <div style={{ color: '#5156BE' }}>
                  <i className="fas fa-chevron-left pe-2"></i>Back to eSign
                  Documents
                </div>
              </NavLink>
              <div className="pt-4">
                <h5>Add New Document</h5>
              </div>
            </div>
            <form className="form" onSubmit={(e) => handleSubmit(e)}>
              <div
                style={{
                  marginTop: '1rem',
                  paddingLeft: '3rem',
                  paddingRight: '3rem',
                  paddingBottom: '6rem',
                }}
              >
                <div className="d-flex border rounded adjust-shadow">
                  <div
                    className="flex-grow-1 bg-white col-md-7"
                    style={{ padding: '2.25rem' }}
                  >
                    <div className="row pb-3 col-md-8">
                      <strong>Status*</strong>
                      <select
                        name="status"
                        className="form-select mt-3 adjust-fs"
                        value={status}
                        onChange={(e) => setStatus(e.target.value)}
                      >
                        <option value="Pending">Pending</option>
                        <option value="Completed">Completed</option>
                      </select>
                    </div>
                    <div className="row pb-3 col-md-8">
                      <strong>Name as per NRIC*</strong>
                      <input
                        type="text"
                        className="form-control mt-3 adjust-fs"
                        value={name}
                        onChange={({ target: { value } }) => setName(value)}
                      />
                    </div>
                    <div className="row pb-3 col-md-8">
                      <strong>NRIC*</strong>
                      <input
                        type="text"
                        className="form-control mt-3 adjust-fs"
                        value={nricFin}
                        onChange={({ target: { value } }) => setNricFin(value)}
                      />
                    </div>
                    <div className="row pb-3 col-md-12">
                      <strong>Salary*</strong>
                      <input
                        type="number"
                        className="form-control mt-3 adjust-fs"
                        value={salary || 0}
                        onChange={({ target: { value } }) => setSalary(value)}
                      />
                    </div>
                    <div className="row pb-3 col-md-12">
                      <strong>Address*</strong>
                      <textarea
                        rows="5"
                        className="form-control mt-3 adjust-fs"
                        style={{ resize: 'none' }}
                        value={address}
                        onChange={({ target: { value } }) => setAddress(value)}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                style={{
                  position: 'fixed',
                  bottom: 0,
                  width: activeSidebar ? 'calc(100vw - 310px)' : '100vw',
                  height: '4.5rem',
                  paddingRight: '3rem',
                }}
                className="border-top bg-white d-flex align-items-center justify-content-end"
              >
                <button
                  type="button"
                  className="btn btn-outline-brand adjust-fs adjust-shadow"
                  style={{ width: '12rem' }}
                  onClick={handleDiscard}
                >
                  Discard
                </button>
                <button
                  type="submit"
                  className="btn btn-brand ms-3 adjust-fs adjust-shadow"
                  style={{ width: '12rem' }}
                >
                  Save changes
                </button>
              </div>
            </form>
          </div>
        );
      }}
    </LayoutContext.Consumer>
  );
};

export default withRouter(AddEsignDocument);
